import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CategoryInfo } from '@models/session-details';
import { ShoppingCategoryItem, ShoppingDataInitialLoad } from '@models/shopping.model';
import { ShoppingCategoryData } from '@models/shopping.model';
import { FilterStateService } from '@services/filter-state/filter-state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-asset-category-filter',
  templateUrl: './asset-category-filter.component.html',
  imports: [CommonModule]
})
export class AssetCategoryFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() categories: ShoppingCategoryData[];
  @Input() is_mobile: boolean = false;
  applied_asset_category: ShoppingDataInitialLoad['categories'] = [];
  private subscriptions: Subscription = new Subscription();

  constructor(private filter_state_svc: FilterStateService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.filter_state_svc.filter_changes.subscribe(
        () => (this.applied_asset_category = this.filter_state_svc.filtersParam.categories)
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.categories && this.categories.length) {
      // filter active category
      const active_category: ShoppingCategoryItem[] = this.categories[0].items.filter(
        (item: ShoppingCategoryItem) => item.active
      );
      CategoryInfo.category_list = this.getAssetCategory(
        active_category[0].item,
        active_category[0].other_group_items,
        this.categories[0].config.filter_config_id
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleCategorySelection(
    filter_config_id: number,
    item: string,
    other_group_items: string[]
  ): void {
    this.applied_asset_category = this.getAssetCategory(item, other_group_items, filter_config_id);
    this.updateFilterParams();
  }

  getAssetCategory(item: string, other_group_items: string[], filter_config_id: number) {
    return [{ id: filter_config_id, value: item }];
  }

  private updateFilterParams(): void {
    const filtersParam: ShoppingDataInitialLoad & {
      countryId: number;
    } = this.filter_state_svc.filtersParam;
    filtersParam.categories = this.applied_asset_category;
    filtersParam.filters = [];

    this.filter_state_svc.filtersParam = filtersParam;
  }
}
